import React from "react";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";
import { toast } from "sonner";
import { fmtDay } from "@/lib/utils";

const SERVICES = ["Breakfast", "Lunch", "Snacks", "Dinner"];
const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const t12 = (t) => {
  const [h, m] = t.split(":").map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
};

const buildHtml = ({ place, date, menus }) => {
  const blocks = SERVICES.filter((s) => menus.some((m) => m.service === s)).map((s) => {
    const list = menus.filter((m) => m.service === s).sort((a, b) => a.time.localeCompare(b.time));
    const items = list.map((m) => `<li><div class="row"><span class="name">${esc(m.item_name)}</span><span class="dots"></span><span class="time">${esc(t12(m.time))}</span></div>${m.description ? `<p>${esc(m.description)}</p>` : ""}</li>`).join("");
    return `<section><h2>${esc(s)}</h2><ul>${items}</ul></section>`;
  }).join("");
  return `<!doctype html><html><head><title>Menu ${esc(place)} ${esc(date)}</title><style>
    @page{size:A4 portrait;margin:12mm}
    *{box-sizing:border-box} body{margin:0;font-family:Georgia,'Times New Roman',serif;color:#1c1917;background:#fff}
    .board{border:6px double #ea580c;border-radius:14px;padding:28px 34px;min-height:96vh}
    header{text-align:center;border-bottom:2px solid #ea580c;padding-bottom:14px;margin-bottom:18px}
    header img{height:58px} h1{font-size:44px;letter-spacing:6px;margin:8px 0 2px;text-transform:uppercase}
    .sub{font-family:Arial,sans-serif;font-size:16px;color:#57534e;letter-spacing:1px}
    .grid{display:grid;grid-template-columns:1fr 1fr;gap:22px 34px}
    section{break-inside:avoid} h2{font-size:26px;color:#c2410c;margin:0 0 8px;border-bottom:1px solid #fdba74;padding-bottom:4px;font-style:italic}
    ul{list-style:none;padding:0;margin:0} li{margin:0 0 12px}
    .row{display:flex;align-items:baseline;gap:8px} .name{font-size:21px;font-weight:bold}
    .dots{flex:1;border-bottom:2px dotted #a8a29e;transform:translateY(-4px)} .time{font-family:Arial,sans-serif;font-size:15px;color:#44403c;white-space:nowrap}
    li p{margin:2px 0 0;font-size:15px;color:#57534e;font-style:italic}
    footer{text-align:center;margin-top:24px;font-family:Arial,sans-serif;font-size:13px;color:#78716c}
  </style></head><body><div class="board">
    <header><img src="${window.location.origin}/baron-logo.jpg" alt="Baron Kitchen"/><h1>Menu of the Day</h1>
    <div class="sub">${esc(place)} · ${esc(fmtDay(date))}</div></header>
    <div class="grid">${blocks}</div>
    <footer>Bon appétit · Baron Kitchen</footer>
  </div><script>window.onload=function(){setTimeout(function(){window.print()},300)}</script></body></html>`;
};

export default function PrintMenuBoard({ place, date, menus }) {
  const print = () => {
    if (!menus.length) return toast.error("No menu to print for this date");
    const w = window.open("", "_blank");
    if (!w) return toast.error("Allow pop-ups to print the menu board");
    w.document.write(buildHtml({ place, date, menus }));
    w.document.close();
  };
  return (
    <Button size="sm" variant="outline" className="gap-2" onClick={print} data-testid="menu-print-board-button">
      <Printer className="h-4 w-4" /> Print Menu Board
    </Button>
  );
}
